import AxiosFactory from "@/repositories/AxiosFactory";

const resource = "/news-items";

export default {
  getNewsItems() {
    return AxiosFactory.get(resource);
  }
};
